export default{
  label:'fill',
  isResponsive:true,
  xs:{
    onValue:'flex-fill',
    offValue:'',
  },
  sm:{
    onValue:'flex-sm-fill',
    offValue:'',
  },
  md:{
    onValue:'flex-md-fill',
    offValue:'',
  },
  lg:{
    onValue:'flex-lg-fill',
    offValue:'',
  },
  xl:{
    onValue:'flex-xl-fill',
    offValue:'',
  },
}


// WEBPACK FOOTER //
// ./src/shell/schemas/utilities/flex/fill.js